module.exports = __webpack_public_path__ + "static/tram_relocation-2fff4070364f12bd4662aeaf6b3ebe01.jpg";